import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 999;
`;

export const OptionsContainer = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  list-style-type: none;

  li {
    cursor: pointer;
    background: var(--black-100);
    margin-bottom: 0.5rem;
    font-family: DM Sans;
    font-weight: 500;
    font-size: 0.875rem;
    padding: 0.4rem 1rem;
    border-radius: 4px;
    transition: background 0.4s;

    &:hover {
      background: var(--primary);
      color: var(--black-100);
    }
  }
`;

type ButtonProps = {
  isActive: boolean;
};

export const Button = styled.button<ButtonProps>`
  align-self: flex-end;
  background: var(--black-100);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.125rem;
  height: 3.125rem;
  border-radius: 6.25rem;

  svg {
    path {
      stroke: var(--grey-100);
    }
  }

  transition: background 0.4s;

  ${({ isActive }) =>
    isActive &&
    css`
      background: var(--primary);

      svg {
        path {
          stroke: var(--black-200);
        }
      }
    `}
`;
